import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon ListsAccountIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const ListsAccountIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        d="M17.5806 8.60059C17.8567 8.60059 18.0806 8.82444 18.0806 9.10059V14.6006H23.2905C23.5665 14.6008 23.7905 14.8246 23.7905 15.1006C23.7904 15.3765 23.5664 15.6003 23.2905 15.6006H18.0806V20.7129C18.0804 20.9889 17.8566 21.2129 17.5806 21.2129C17.3046 21.2128 17.0807 20.9889 17.0806 20.7129V15.6006H11.6772C11.4012 15.6005 11.1774 15.3766 11.1772 15.1006C11.1772 14.8245 11.4012 14.6007 11.6772 14.6006H17.0806V9.10059C17.0806 8.82448 17.3045 8.60065 17.5806 8.60059Z"
        fill="#503291"
      />
      <path
        d="M9.27881 12.8008C9.55495 12.8008 9.77881 13.0246 9.77881 13.3008C9.77881 13.5769 9.55495 13.8008 9.27881 13.8008H0.709961C0.433987 13.8006 0.209961 13.5768 0.209961 13.3008C0.209961 13.0248 0.433987 12.801 0.709961 12.8008H9.27881Z"
        fill="#503291"
      />
      <path
        d="M13.4019 7.80078C13.678 7.80078 13.9019 8.02464 13.9019 8.30078C13.9019 8.57692 13.678 8.80078 13.4019 8.80078H0.709961C0.433987 8.80058 0.209961 8.5768 0.209961 8.30078C0.209961 8.02476 0.433987 7.80098 0.709961 7.80078H13.4019Z"
        fill="#503291"
      />
      <path
        d="M13.4019 2.78711C13.678 2.78711 13.9019 3.01097 13.9019 3.28711C13.9019 3.56325 13.678 3.78711 13.4019 3.78711H0.709961C0.433987 3.78691 0.209961 3.56313 0.209961 3.28711C0.209961 3.01109 0.433987 2.78731 0.709961 2.78711H13.4019Z"
        fill="#503291"
      />
    </Icon>
  )
}
export default ListsAccountIcon
